// extracted by mini-css-extract-plugin
export default {"more-product-photos":"ProductGallery_more-product-photos__Gdpf5","active-image":"ProductGallery_active-image__su5RL"};